import { useRequiredContext } from "@redotech/react-util/context";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useReclaimAccessDefaults } from "../../finance/disputes/use-reclaim-access-defaults";
import { useSetupGuideOptional } from "../../setup-guide/provider/use-setup-guide";
import { OnboardingProps } from "../common";

export const ReclaimAnnouncementOnboarding = memo(
  function ReclaimAnnouncementOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const team = useRequiredContext(TeamContext);
    const navigate = useNavigate();
    const setupGuide = useSetupGuideOptional();
    const { termsCopy } = useReclaimAccessDefaults({ source: "intake_modal" });

    // Hide the card if the merchant already has a setup-guide row for
    // disputes (they've engaged with the new flow). Also hide while the
    // setup-guide context is still loading to prevent a brief flash of
    // the card before it disappears once data arrives.
    if (setupGuide) {
      if (setupGuide.loading) {
        return null;
      }
      if (setupGuide.progressByProduct.disputes != null) {
        return null;
      }
    }

    const handleAction = () => {
      // When the setup-guide flag is on, route through the new entry path
      // so the provider creates a row + opens the intake modal.
      if (setupGuide) {
        navigate(
          `/stores/${team._id}/finance/disputes/dashboard?setupSource=homepage_card`,
        );
      } else {
        navigate(`/stores/${team._id}/finance/disputes`);
      }
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText={termsCopy.cta}
        description={termsCopy.announcementDescription}
        image="https://assets.getredo.com/reclaim-announcement.png"
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Recover chargeback revenue with Reclaim"
      />
    );
  },
);
